import axios from "axios";
import { RingLoader } from "react-spinners";
import { Helmet } from 'react-helmet';
import classNames from "classnames"
import React, { useState, useEffect } from "react";
import { Tooltip } from 'react-tooltip';
import AdSense from 'react-adsense';
import { alert_error, alert_success } from "../AppContext.js";
import Select from "react-select"
const TikTokComponent = ({ theloaiMXH, dataTheLoaiMXH }) => {
  // useState for Select
  const [theloaiOption, setTheLoaiOption] = useState(theloaiMXH[0]);
  const [loadingtheloai, setloadingtheloai] = useState(false);
  const [chuyenMucOption, setChuyenMucOption] = useState();
  const [typeOpen, setTypeOpen] = useState(true);
  const [typeChuyenMucOpen, setTypeChuyenMucOpen] = useState(false);
  // useState for data api
  const [chuyenMuc, setChuyenMuc] = useState([]);
  const [dataChuyenMuc, setDataChuyenMuc] = useState([]);
  const [loadingchuyenmuc, setloadingchuyenmuc] = useState(false);
  const [dataPrice, setDataPrice] = useState([]);
  useEffect(() => {
    if (loadingtheloai) {
      console.log(123);
      setTheLoaiOption(theloaiMXH[0]);
    };
  }, [loadingtheloai])
  useEffect(() => {
    if (dataChuyenMuc) {
      setChuyenMuc([]);
    };
    let res = axios
      .post("https://hust.media/getservice/category.php", handleProcessData(dataTheLoaiMXH, theloaiOption))
      .then((res) => {
        if (res.data) {
          setloadingtheloai(false);
          setDataChuyenMuc(res.data)
          let data = []
          res.data.map((item) => {
            return data.push({
              value: item.name, label: item.name,
              img: item.img
            })
          })
          setChuyenMuc(data)
        }
      })
    return () => {
      res = null
      // res1 = null
    }
  }, [theloaiOption, dataTheLoaiMXH])
  useEffect(() => {
    if (chuyenMucOption) {
      let res1 = axios
        .post(
          "https://hust.media/getservice/service.php",
          handleProcessDataRate(dataChuyenMuc, chuyenMucOption),
        )
        .then((res) => {
          if (res.data) {
            setloadingchuyenmuc(false);
            setDataPrice(res.data)
          }
        })
    }
  }, [chuyenMucOption])
  const handleProcessData = (data, name) => {
    const result = data.find((item) => {
      return item.name === name.value
    })
    return { social: result?.social, theloai: result?.code }
  }
  const handleProcessDataRate = (data, name) => {
    if (name) {
      const result = data.find((item) => {
        if (chuyenMuc != '[]' && chuyenMuc) {
          setloadingchuyenmuc(true);
        }
        return item.name === name.value;
      });
      return { category: result?.code };
    }
  };
  // console.log(dataPrice)
  return (
    <div className="px-3 mt-2">
      <div className="px-3 py-2 border-blue-400 border-2 rounded-lg bg-[#f5f6fa]">
        <p className=" flex justify-center mb-0 mt-0 text-sm">Chọn thể loại</p>
        <Select
          className="text-xs lg:text-base"
          // defaultValue={theloaiOption}
          onChange={setTheLoaiOption}
          options={theloaiMXH}
          getOptionLabel={(item) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '5px' }}>{item.label}</span>
              {item.img &&
                (<img
                  src={item.img}
                  alt={`${item.value} img`}
                  style={{ width: '20px', height: '20px' }}
                />
                )}
            </div>
          )}
          menuIsOpen={typeOpen}
          isSearchable={false}
          onMenuOpen={() => setTypeOpen(true)}
          onMenuClose={() => {
            setTypeOpen(false);
            setTypeChuyenMucOpen(true);
          }}
        />
        <p className=" flex justify-center mb-0 mt-2 text-sm">Chọn chuyên mục</p>
        <Select
          className="mb-1 text-xs lg:text-base"
          defaultValue={chuyenMucOption}
          onChange={setChuyenMucOption}
          options={chuyenMuc}
          getOptionLabel={(item) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '5px' }}>{item.label}</span>
              <img
                src={item.img}
                alt={`${item.value} img`}
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          )}
          menuIsOpen={typeChuyenMucOpen}
          isSearchable={false}
          onMenuOpen={() => setTypeChuyenMucOpen(true)}
          onMenuClose={() => {
            setTypeChuyenMucOpen(false);
          }}
        />
      </div>
      <div className="border-blue-400 border-2 rounded-lg bg-[#f5f6fa] mt-2 p-2">
        {loadingchuyenmuc ? (
          <>
            <div className="flex justify-center items-center">
              <RingLoader size={80} color="#0000ff" />{" "}
            </div>
          </>
        )
          : dataPrice ?
            (
              <table className="mt-2 mx-auto w-full">
                <tr className="border px-2 py-1 text-center">
                  <td className="border px-2 py-1 text-xs md:text-base">Name</td>
                  <td className="border px-2 py-1 text-xs md:text-base">
                    Tối thiểu
                  </td>
                  <td className="border px-2 py-1 text-xs md:text-base">Tối đa</td>
                  <td data-tooltip-id="my-tooltip"
                    className="border px-2 py-1 text-xs md:text-base"
                    data-tooltip-content="💫Giá trên 1 đơn vị🎀 "
                    data-tooltip-place="left"
                  >
                    Giá tiền !
                    <Tooltip className="max-w-xs mx-auto mb-0 break-all" id="my-tooltip" />
                  </td>
                </tr>
                {dataPrice.length > 0 &&
                  dataPrice.map((item) => {
                    return (
                      <tr className="border px-2 py-1">
                        <td className="border px-2 py-1 text-xs md:text-base">
                          {item.name}
                        </td>
                        <td className="text-center border px-2 py-1 text-xs md:text-base">
                          {item.minorder}
                        </td>
                        <td className="text-center border px-2 py-1 text-xs md:text-base">
                          {item.maxorder}
                        </td>
                        <td className="text-center border px-2 py-1 text-xs md:text-base">
                          {item.money}
                        </td>
                      </tr>
                    );
                  })}
              </table>
            ) : (<></>)}
      </div>
    </div>
  );
}
function Costsocial() {
  const [loadinglandau, setlloadinglandau] = useState(true)
  const [userOption, setUserOption] = useState('Tiktok')
  const [theloaiMXH, setTheloaiMXH] = useState([])
  const [dataTheLoaiMXH, setDataTheLoaiMXH] = useState([])
  const [application, setapplication] = useState([])
  const [landaunhapbieutuong, setlandaunhapbieutuong] = useState(true)
  useEffect(() => {
    laydulieu();
  }, []);
  function laydulieu() {
    setlloadinglandau(true);
    axios
      .get(`https://hust.media/getservice/application.php?theloai=app`)
      .then((response) => {
        if (response.data) {
          setapplication(response.data);
          console.log(response.data);
          setlloadinglandau(false);
        }
      })
      .catch((error) => alert_error(error));
  };
  function thaydoiapp(UserOption) {
    setlandaunhapbieutuong(false);
    setUserOption(UserOption)
  };
  useEffect(() => {
    if (userOption) {
      let res = axios
        .get(`https://hust.media/getservice/application.php?theloai=danhmuc&app=${userOption}`)
        .then((response) => {
          if (response.data) {
            setDataTheLoaiMXH(response.data)

            let data = []
            response.data.map((item) => {
              return data.push({ value: item.name, label: item.name, img: item.img })
            })
            setTheloaiMXH(data)


          }
        })
      return () => {
        res = null
      }
    }

  }, [userOption])
  // if (theloaiMXH.length === 0) return null
  return (
    <>
      <Helmet>
        <title>Bảng giá dịch vụ tăng like/sub/follow</title>
        <meta name="description" content="Bảng giá dịch vụ tăng like/sub/follow Facebook, Instagram, Tiktok, Youtube,... " />
        {/* Các thẻ meta khác */}
      </Helmet>

      <div className="max-h-16">
        <div className="cards">
          <AdSense.Google
            client="ca-pub-4574266110812955"
            slot="1627514116"
            style={{ display: 'block', height: 50 }}
            format=""
          /> </div>
      </div>
      {loadinglandau ? (
        <>
          <div className="flex justify-center items-center">
            <RingLoader size={80} color="#0000ff" />
          </div>
        </>
      ) : (<>

        <div className='flex justify-center mt-1 gap-2'>
          {application.map((option) => (
            <div style={{ display: 'flex', alignItems: 'center' }}
              onClick={() => {
                thaydoiapp(option.code);
              }} className="rounded-md border-2 cursor-pointer px-1 py-1">
              <div
                key={option.code}
                className={`text-xs lg:text-base  ${classNames({
                  "border-blue-600": userOption === option.code,
                })}`}>
                {option.name}
              </div>
              <span style={{ marginRight: '2px' }}></span>
              <img
                src={option.img}
                alt={`${option.img}`}
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          ))}
        </div>
        {landaunhapbieutuong ?
          (
            <div className='flex justify-center mt-4 gap-2 text-base font-bold text-white'>
              Nhấp vào biểu tượng để xem bảng giá ứng dụng
            </div>
          ) :
          (
            <>
              {userOption === "Tiktok" && <TikTokComponent theloaiMXH={theloaiMXH} dataTheLoaiMXH={dataTheLoaiMXH} />}
              {userOption === "Facebook" && <TikTokComponent theloaiMXH={theloaiMXH} dataTheLoaiMXH={dataTheLoaiMXH} />}
              {userOption === "Instagram" && <TikTokComponent theloaiMXH={theloaiMXH} dataTheLoaiMXH={dataTheLoaiMXH} />}
              {userOption === "Youtube" && <TikTokComponent theloaiMXH={theloaiMXH} dataTheLoaiMXH={dataTheLoaiMXH} />}</>
          )

        }
      </>)}



    </>
  )
}

export default Costsocial
